

















import { Component, Vue, Watch } from 'vue-property-decorator'
import FriendList from '@/components/FriendList.vue'
import CategoryMedia from '@/components/media/CategoryMedia.vue'
import BackButton from '@/components/BackButton.vue'
import pages from '@/constants/pages'
import { EFriend, friends } from '@/types/categories/friend'

@Component({
  components: {
    FriendList,
    CategoryMedia,
    BackButton
  }
})
export default class SolveView extends Vue {
  get selectedFriend () {
    return this.$store.getters['selectedFriend']
  }

  get boardFriends () {
    return this.$store.getters['boardFriends'] as Array<String>
  }

  get friendList () {
    return this.boardFriends.filter((f: String) => f !== this.selectedFriend)
  }

  protected onFriendClicked (friend: EFriend) {
    this.$store.dispatch('solve', friend)
    this.$router.push(pages.GAME_OVER_PATH)
  }
}
